<template>
    <div>
        <div class="row no-gutters shadow-sm bg-sidebar text-white mt-2">
            <div class="col-md-12">
                <div class="groupName pl-2">
                    <div class="float-left pointer">
                        <span class="badge" :style="'background-color: ' + group.color">
                            &nbsp;&nbsp;
                        </span>
                        <span v-if="group.name !== ''">
                            {{ group.name }}
                        </span>
                        <span class="pl-1" v-else>
                            <i>{{ $t('UI_INSTANCE_MEMBER_GROUP_UNNAMED') }}</i>
                        </span>
                    </div>

                    <span class="float-right pr-1">
                        <i class="fa fa-edit text-warning ml-2 pointer" :key="1" @click="openEditGroupModal()"></i>
                        <i class="fa fa-trash text-danger ml-2 pointer" :key="2" @click="deleteGroup()"></i>
                    </span>

                    <span class="clearfix"></span>
                </div>
            </div>
        </div>

        <!-- Move Group Bar -->
        <div class="card bg-light" >
            <div class="row no-gutters">
                <div class="col-md-12 text-center">
                    <i @click="moveGroup('up')" :class="getArrowTextColor('up')" class="fa fa-arrow-up pointer hoverColorChange"></i>
                    <i @click="moveGroup('down')" :class="getArrowTextColor('down')" class="fa fa-arrow-down pointer hoverColorChange ml-2"></i>
                    <i @click="moveGroup('left')" :class="getArrowTextColor('left')" class="fa fa-arrow-left pointer hoverColorChange ml-2"></i>
                    <i @click="moveGroup('right',)" :class="getArrowTextColor('right')" class="fa fa-arrow-right pointer hoverColorChange ml-2"></i>
                </div>
            </div>
        </div>

        <!-- Member List -->
        <div class="card">
            <Container group-name="groupContainer"
                       @drop="(dropResult) => onDrop(dropResult, group)"
                       :get-child-payload="(index) => getChildPayload(index, group)">

                <Draggable v-for="member in group.members">
                    <div class="row no-gutters draggable-item dragCursor"  :key="member.id">
                        <div class="col-md-10" :class="getMemberBackgroundClass(member)">
                            <span class="badge ml-2" :style="'background-color: ' + group.color_light">&nbsp;&nbsp;</span>
                            <span>&nbsp;{{ member.name }}</span>
                        </div>
                        <div class="col-md-2 text-right">
                            <MemberEdit :member="member" :group="group"/>
                            <MemberDelete :member="member" :group="group"/>
                        </div>
                    </div>
                </Draggable>
            </Container>
        </div>
        <MemberAdd :group="group" key="memberadd"/>

        <!-- Edit Group Modal -->
        <sweet-modal :title="$t('UI_INSTANCE_MEMBER_GROUP_EDIT')" ref="editGroupModal">
            <div class="form-group">
                <label for="title">{{ $t("UI_INSTANCE_MEMBER_GROUP_TITLE") }}</label>
                <input type="text" id="title" v-model="newValues.title" :placeholder="$t('UI_INSTANCE_MEMBER_GROUP_TITLE')" class="form-control">
            </div>

            <div class="form-group">
                <label for="color">{{ $t('UI_INSTANCE_MEMBER_GROUP_COLOR') }}</label>
                <swatches v-model="newValues.color" id="color" inline></swatches>
            </div>


            <div slot="button">
                <button class="btn btn-primary" @click="editGroup">
                    {{ $t("UI_MODAL_BUTTON_SAVE") }}
                </button>
                <button class="btn btn-secondary ml-1" @click="$refs.editGroupModal.close()">
                    {{ $t("UI_MODAL_BUTTON_CLOSE") }}
                </button>
            </div>
        </sweet-modal>

    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import Swatches from 'vue-swatches';

import { Draggable, Container } from 'vue-smooth-dnd';
import { RepositoryFactory } from '../../../../../repositories/RepositoryFactory';
import MemberDelete from './MemberDelete';
import MemberEdit from './MemberEdit';
import MemberAdd from './MemberAdd';


const ChannelMemberRepository = RepositoryFactory.get('channelMembers');

export default {
  name: 'SingleGroup',
  props: ['group'],
  components: {
    MemberAdd,
    MemberDelete,
    MemberEdit,
    Swatches,
    SweetModal,
    Draggable,
    Container,
  },
  data() {
    return {
      newValues: {
        id: this.group.id,
        title: this.group.name,
        color: this.group.color,
      },
      drag: false,
    };
  },
  methods: {
    // Member Drag & Drop
    getChildPayload(index) {
      return this.group.members.find(member => member.order === index);
    },

    async onDrop(dropResult, group) {
      const { removedIndex, addedIndex, payload } = dropResult;
      const member = payload;

      const { moving } = this.$parent;

      if (removedIndex === null && addedIndex === null) { return false; }

	    if (removedIndex !== null) {
		    // This is the source container
		    moving.sourceGroup = group;
	    }
	    if (addedIndex !== null) {
		    // this is the target container
		    moving.targetGroup = group;
		    moving.targetPosition = addedIndex;
	    }

	    // if source & Target groups are set
	    if (moving.sourceGroup !== null && moving.targetGroup !== null) {
		    // Check the Payload. Payload should contain the member object being moved.
		    if (member !== undefined && member !== null) {
			    this.isLoading = true;
			    await ChannelMemberRepository.moveMember(moving.sourceGroup.id, moving.targetGroup.id, member.id, moving.targetPosition).then(() => {
				    // Reset Selections
				    moving.sourceGroup = null;
				    moving.targetGroup = null;
				    moving.targetPosition = null;

				    ChannelMemberRepository.refetchMemberList();
			    });
		    }
	    }
    },


    async editGroup() {
      const vm = this;
      await ChannelMemberRepository.modifyGroup(this.newValues.id, this.newValues.title, this.newValues.color)
        .then(() => {
          this.$snotify.info(this.$t('UI_INSTANCE_MEMBER_GROUP_MODIFIED', { name: this.newValues.title }));
          ChannelMemberRepository.refetchMemberList();
          this.$refs.editGroupModal.close();
        });
    },
    openEditGroupModal() {
      this.$refs.editGroupModal.open();
    },

    async deleteGroup() {
      ChannelMemberRepository.deleteGroup(this.group.id).then(() => {
        this.$snotify.info(this.$t('UI_INSTANCE_MEMBER_GROUP_DELETED', { name: this.group.name }));
        ChannelMemberRepository.refetchMemberList();
      });
    },

    getMemberBackgroundClass(member, group) {
      return member.order % 2 ? 'entry-grey' : '';
    },

    /**
       * ======= ARROW MOVE ACTIONS ==========
       */
    moveGroup(direction) {
      if (!this.canMoveGroupInDirection(direction)) { return false; }

      switch (direction) {
        case 'up':
          return ChannelMemberRepository.moveGroupUp(this.group)
            .then(() => ChannelMemberRepository.refetchMemberList());
        case 'down':
          return ChannelMemberRepository.moveGroupDown(this.group)
            .then(() => ChannelMemberRepository.refetchMemberList());
        case 'left':
          return ChannelMemberRepository.moveGroupLeft(this.group)
            .then(() => ChannelMemberRepository.refetchMemberList());
        case 'right':
          return ChannelMemberRepository.moveGroupRight(this.group)
            .then(() => ChannelMemberRepository.refetchMemberList());
        default:
          return false;
      }
    },

    canMoveGroupInDirection(direction) {
      switch (direction) {
        case 'up':
          return this.group.order !== 0;
        case 'down':
          return this.group.order !== this.getHighestSortForColumn(this.group.column);
        case 'left':
          return this.group.column !== 0;
        case 'right':
          return this.group.column !== 1;
        default:
          return 'text-dark';
      }
    },

    // Determines the Color for the arrow
    getArrowTextColor(direction) {
      return this.canMoveGroupInDirection(direction) ? 'text-dark' : 'text-grey';
    },
    // Returns the Highest Sort available for the column
    getHighestSortForColumn(column) {
      const groups = this.$store.getters.activeChannelMemberList.filter(group => group.column === column);

      const sort = groups.map(group => group.order)
        .sort((a, b) => a - b);
      return Math.max(...sort);
    },
    /**
       * ======= ARROW MOVE END ==========
       */
  },
};
</script>
